import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { useReportContext } from '../../../../context/DetailContext';

const NPLNavigationTab = () => {
  const [currentTab, setCurrentTab] = useState('NPL 분석요약');
  const [isFixed, setIsFixed] = useState(false);
  const [isFull, setIsFull] = useState(false);
  const { type } = useReportContext();

  const TabButtons = [
    { name: '분석요약' },
    { name: '물건개요' },
    { name: '부동산현황' },
    { name: '매각기일' },
    { name: '선순위내역' },
    { name: '투자기간' },
    { name: '대출원리금' },
    { name: '배당분석' },
    { name: '비용분석' },
    { name: '수익분석' },
  ];

  const navRef = useRef<HTMLDivElement | null>(null);
  const initialTop = useRef<number>(0);

  useEffect(() => {
    const handleResize = () => setIsFull(window.innerWidth > 900);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (!navRef.current) return;
      const navOffset =
        navRef.current.getBoundingClientRect().top + window.scrollY;

      if (initialTop.current === 0) {
        initialTop.current = navOffset;
      }

      setIsFixed(window.scrollY > initialTop.current);

      const offset = 140;
      for (let i = 0; i < TabButtons.length; i++) {
        const element = document.getElementById(TabButtons[i].name);
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= offset && rect.bottom > offset) {
            setCurrentTab(TabButtons[i].name);
            const el2 = document.getElementById(TabButtons[i].name + '_nav');
            if (el2 && navRef.current) {
              navRef.current.scrollTo({
                left: el2.offsetLeft - 10,
                behavior: 'smooth',
              });
            }
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleScroll = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 120;
      const elementPosition =
        element.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: elementPosition - offset, behavior: 'smooth' });
    }
  };

  return (
    <Container ref={navRef} isFull={isFull} isFixed={isFixed}>
      <Inner>
        {TabButtons.map((tab, idx) => (
          <TabButton
            key={idx}
            onClick={() => handleScroll(tab.name)}
            active={currentTab === tab.name}
            id={tab.name + '_nav'}
          >
            {tab.name}
          </TabButton>
        ))}
      </Inner>
    </Container>
  );
};

export default NPLNavigationTab;

interface ContainerProps {
  isFull: boolean;
  isFixed: boolean;
}

const Container = styled.div<ContainerProps>`
  position: ${(props) => (props.isFixed ? 'fixed' : 'relative')};
  top: ${(props) => (props.isFixed ? '54px' : 'auto')};
  width: ${(props) => (props.isFull ? '900px' : '100%')};
  overflow-x: auto;
  background-color: #fff;

  /* 스크롤바 숨기기 */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE, Edge */

  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari */
    height: 8px;
  }
  z-index: 100;
`;
const Inner = styled.div`
  padding: 0 8px;
  display: flex;
  flex-direction: row;
  overflow-x: scroll;
  border-bottom: 1px solid #e5e8ea;
`;
const TabButton = styled.div<{ active: boolean }>`
  padding: 13px 9px;
  font-size: 16px;
  font-weight: 500;
  white-space: nowrap;
  border-bottom: ${({ active }) => active && ' 2px solid #222'};

  color: ${(props) => (props.active ? '#222222' : '#989BA2')};
  cursor: pointer;
  /* background-color: ${(props) =>
    props.active ? '#222222' : 'rgba(112, 115, 124, 0.08)'}; */
`;
